import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface ReportEventAddDetailsState {
  posterDataUrls: string[];
  description: string;
  setPosterDataUrls: (urls: string[]) => void;
  addPosterDataUrls: (urls: string[]) => void;
  removePosterDataUrl: (index: number) => void;
  clearPosterDataUrls: () => void;
  setDescription: (description: string) => void;
  clear: () => void;
}

export const useReportEventAddDetailsStore = create<ReportEventAddDetailsState>()(
  persist(
    (set, get) => ({
      posterDataUrls: [],
      description: '',
      setPosterDataUrls: (urls) => set({ posterDataUrls: urls }),
      addPosterDataUrls: (urls) => {
        const merged = [...get().posterDataUrls, ...urls];
        set({ posterDataUrls: merged });
      },
      removePosterDataUrl: (index) =>
        set((state) => ({
          posterDataUrls: state.posterDataUrls.filter((_, i) => i !== index)
        })),
      clearPosterDataUrls: () => set({ posterDataUrls: [] }),
      setDescription: (description) => set({ description }),
      clear: () => set({ posterDataUrls: [], description: '' })
    }),
    {
      name: 'report-event-add-details',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);
